import { render, staticRenderFns } from "./PeriodManagement.vue?vue&type=template&id=99b1641e&"
import script from "./PeriodManagement.vue?vue&type=script&lang=js&"
export * from "./PeriodManagement.vue?vue&type=script&lang=js&"
import style0 from "./PeriodManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports